import { CreateTransactionResponseData } from "@ac-expo/api-types";
import { z } from "zod";

export const guestIdentitySchema = z.object({
  email: z.string().email("Veuillez entrer un email valide"),
  firstName: z.string().min(1, "Veuillez entrer un prénom"),
  lastName: z.string().min(1, "Veuillez entrer un nom"),
});

export const guestIdentityFields = ["email", "firstName", "lastName"] as const;
export type GuestIdentityField = (typeof guestIdentityFields)[number];

function createAndPopulateForm(
  fields: CreateTransactionResponseData["fields"],
  url: string,
  target?: string
) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  if (target) form.target = target;

  for (const [key, value] of fields) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = String(value);
    form.appendChild(input);
  }

  document.body.appendChild(form);
  return form;
}

export function navigateToPayment({
  fields,
  url,
}: CreateTransactionResponseData) {
  const form = createAndPopulateForm(fields, url);
  form.submit();
}

export function navigateToPaymentIframe({
  fields,
  url,
}: CreateTransactionResponseData) {
  const iframeName = "paymentIframe";

  const iframe = document.querySelector(
    `iframe[name="${iframeName}"]`
  ) as HTMLIFrameElement | null;
  if (!iframe) {
    console.error(`Iframe with name "${iframeName}" not found.`);
    return;
  }

  const form = createAndPopulateForm(fields, url, iframeName);
  form.submit();
  document.body.removeChild(form);
}
